const pkg: Record<string, any> = {
    name: "updateAnnouncementList",
    path: "/app-updateAnnouncementList",
    component: "basic",
    meta: {
        title: "updateAnnouncementList",
        i18nTitle: "Routes.updateAnnouncementList.list",
        requiresAuth: true,
        keepAlive: true,
        icon: "fluent:book-information-24-regular",
        order: 2,
        permissions: ["system:announcement:list"],
    },
    children: [
        {
            name: "updateAnnouncementList_list",
            path: "/updateAnnouncementList/list",
            component: "self",
            meta: {
                title: "updateAnnouncementList",
                i18nTitle: "Routes.updateAnnouncementList.list",
                requiresAuth: true,
                keepAlive: true,
                icon: "ic:round-tab",
            },
        },
    ],
}

export default pkg
